const firebaseConfig = {
    apiKey: "AIzaSyDMiIgbIYYF_hcYuLdQLqI72dBiDAetFq8",
    authDomain: "mediyot-healthcare.firebaseapp.com",
    projectId: "mediyot-healthcare",
    storageBucket: "mediyot-healthcare.appspot.com",
    messagingSenderId: "297261270353",
    appId: "1:297261270353:web:f2d8359191700f5254bf70"
  };
  export default firebaseConfig;